/**
 * Default pagination settings
 */
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
  DEFAULT_PAGE: 0,
} as const;

/**
 * Default sorting configurations
 */
export const SORTING = {
  DEFAULT_SORT_FIELD: 'created',
  DEFAULT_SORT_ORDER: 'desc' as const,
  DATE_FIELDS: ['created', 'lastUpdated', 'lastActivity', 'orderDate'],
} as const;


/**
 * Default search fields for different entity types
 */
export const SEARCH_FIELDS = {
  CUSTOMERS: ['id', 'name', 'email'],
  DISPUTES: ['id', 'customer.name', 'customer.email', 'paymentId', 'reason'],
  REFUNDS: ['id', 'paymentId', 'customer.name', 'customer.email', 'description'],
  MERCHANTS: ['id', 'name', 'email', 'acceptorName', 'legalBusinessName'],
  PAYMENTS: ['transactionRef', 'customer.name', 'customer.email'],
  ORDERS: ['orderId', 'description', 'store', 'customer'],
  INVENTORY: ['model', 'serialNumber', 'store'],
  ECOMMERCE: ['name', 'description'],
  PAYMENT_LINKS: ['name', 'id'],
  INVOICES: ['invoiceNumber', 'customerName', 'customerEmail', 'description'],
  QUOTES: ['quoteNumber', 'customer', 'customerEmail'],
  VELOCITY: ['velocityId', 'description', 'program', 'merchant'],
};

/**
 * Default facet fields for different entity types
 */
export const FACET_FIELDS = {
  CUSTOMERS: ['status', 'riskLevel'],
  DISPUTES: ['status', 'reason', 'currency'],
  REFUNDS: ['status'],
  MERCHANTS: ['status', 'type'],
  PAYMENTS: ['status', 'type'],
  ORDERS: ['status', 'priority'],
  INVENTORY: ['status', 'model'],
  ECOMMERCE: ['status', 'type', 'environment'],
  PAYMENT_LINKS: ['status', 'type'],
  INVOICES: ['status', 'currency', 'frequency'],
  QUOTES: ['status', 'currency'],
  VELOCITY: ['status'],
};

/**
 * Error messages for different operations
 */
export const ERROR_MESSAGES = {
  NOT_FOUND: (entityType: string, id: string) => `${entityType} ${id} not found`,
  FETCH_FAILED: (entityType: string) => `Failed to fetch ${entityType.toLowerCase()}`,
  UPDATE_FAILED: (entityType: string) => `Failed to update ${entityType.toLowerCase()}`,
  DELETE_FAILED: (entityType: string) => `Failed to delete ${entityType.toLowerCase()}`,
  CREATE_FAILED: (entityType: string) => `Failed to create ${entityType.toLowerCase()}`,
  VALIDATION_FAILED: (entityType: string) => `${entityType} validation failed`,
  PERMISSION_DENIED: (operation: string) => `Permission denied for ${operation}`,
} as const;

/**
 * Standard response status codes
 */
export const STATUS_CODES = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
} as const;
